/**
 * IntervalsFieldButton - Intervals (spacing/flow rate) field button using existing hooks
 */

import {useLoadSpacing} from '@hconnect/tuc-processes/fields/loadSpacing'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FieldButton} from '../../FieldButton'

interface IntervalsFieldButtonProps {
  onClick: () => void
  requiresApproval?: boolean
  isReadOnly?: boolean
  isChanged?: boolean
}

export const IntervalsFieldButton: React.FC<IntervalsFieldButtonProps> = ({
  onClick,
  requiresApproval = false,
  isReadOnly = false,
  isChanged = false
}) => {
  const {t} = useTranslation()
  const {spacingOrFlowRate, timeOnJobSite} = useLoadSpacing()

  // Following useRmcOrderEditLogic pattern exactly
  const spacingInfo = (() => {
    if (!spacingOrFlowRate) return null

    const isLoadSpace = spacingOrFlowRate.type === 'loadSpace'
    const typeLabel = isLoadSpace
      ? t('orderIntake.rmc.orderManagement.spacing', 'loadSpace')
      : t('orderIntake.rmc.orderManagement.flowRate', 'Flow rate')
    const value = isLoadSpace ? spacingOrFlowRate.loadSpace : spacingOrFlowRate.flowRate
    const unit = isLoadSpace ? spacingOrFlowRate.loadSpaceUom : spacingOrFlowRate.flowRateUom

    if (value === null || value === undefined || !unit) {
      return null
    }

    return `${typeLabel} - ${value} ${unit}`
  })()

  const timeOnSiteInfo = timeOnJobSite
    ? `${t('orderIntake.rmc.orderManagement.timeOnSite', 'Time on site')} - ${timeOnJobSite.time} ${
        timeOnJobSite.timeUom
      }`
    : null

  const parts = [spacingInfo, timeOnSiteInfo].filter(Boolean) as string[]
  const displayValue = parts.length > 0 ? parts.join(', ') : null

  return (
    <FieldButton
      label={t('orderIntake.rmc.orderManagement.editSteps.labels.intervals', 'Intervals')}
      value={displayValue}
      onClick={onClick}
      requiresApproval={requiresApproval}
      isReadOnly={isReadOnly}
      isChanged={isChanged}
    />
  )
}
